import { defineNuxtPlugin } from '@nuxtjs/composition-api';

export default defineNuxtPlugin((context, inject) => {
  // Create $craft and inject it into Vue components
  // Usage: `this.$craft({ query: gqlQuery, variables: { uri: `code/${this.$route.params.slug}` } })`

  inject('craft', async (params) => {
    // Destructuring from context
    const { $config, $preview, query} = context;

    // eslint-disable-next-line no-console
    console.log(`🗄 API call${params.apiLog ? ': ' + params.apiLog : ''}`);
    // eslint-disable-next-line no-console
    console.log(`  🔍 Preview: ${$preview ? 'true' : 'false'}`);
    /*
     * Serverless Method
     * Use serverless functions, like Lambda or Netlify functions
     */
    if ($preview && query?.token && $config.livePreviewEndpoint) {
      const previewPayload = {
        request: params,
        token: query.token,
      };

      try {
        const response = await fetch($config.livePreviewEndpoint, {
          method: 'POST',
          body: JSON.stringify(previewPayload),
        });
        return response.json();
      } catch (err) {
        const error = err instanceof Error ? err : new Error(String(err));
        if (!error.statusCode) {
          error.statusCode = 404;
        }
        throw error;
      }
    }

    if ($config.craftApiUrl && $config.craftAuthToken) {
      try {
        const previewToken = $preview && query?.token ? `?token=${query.token}` : '';
        const response = await fetch($config.craftApiUrl + previewToken, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${$config.craftAuthToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });
        return response.json();
      } catch (err) {
        const error = err instanceof Error ? err : new Error(String(err));
        if (!error.statusCode) {
          error.statusCode = 404;
        }
        throw error;
      }
    }
    return {
      error: { error: `No connection information set.` },
    };
  });
});
